import { IOptionItem } from "@/components/ui/dropdown/types";
import { MESSAGE } from "@/constants/message";
import { EOutputCoverageType } from "@/types/spatial";

export const GEOHASH_RESOLUTION: IOptionItem[] = [
  {
    label: "1 ≤ 5,000km x 5,000km",
    value: "1"
  },
  {
    label: "2 ≤ 1,250km x 625km",
    value: "2"
  },
  {
    label: "3 ≤ 156km x 156km",
    value: "3"
  },
  {
    label: "4 ≤ 39.1km x 19.5km",
    value: "4"
  },
  {
    label: "5 ≤ 4.89km x 4.89km",
    value: "5"
  },
  {
    label: "6 ≤ 1.22km x 0.61km",
    value: "6"
  }
];

export interface H3CustomOption extends IOptionItem {
  radius: string;
}

export const H3_RESOLUTION: H3CustomOption[] = [
  {
    label: "609,788.44 Km2",
    radius: "483.05 Km",
    value: "1"
  },
  {
    label: "86,801.78 Km2",
    radius: "182.51Km",
    value: "2"
  },
  {
    label: "12,393.43Km2",
    radius: "68.97Km",
    value: "3"
  },
  {
    label: "1,770.34Km2",
    radius: "26.07Km",
    value: "4"
  },
  {
    label: "252.90Km2",
    radius: "9.85Km",
    value: "5"
  },
  {
    label: "36.12Km2",
    radius: "3.72Km",
    value: "6"
  },
  {
    label: "5.16Km2",
    radius: "1.40Km",
    value: "7"
  },
  {
    label: "0.73Km2",
    radius: "0.53Km",
    value: "8"
  },
  {
    label: "0.10Km2",
    radius: "0.20Km",
    value: "9"
  },
  {
    label: "0.01Km2",
    radius: "0.07Km",
    value: "10"
  }
];

export const COVERAGE_TYPE: IOptionItem[] = [
  {
    label: "Standard",
    value: EOutputCoverageType.STANDARD,
    description: MESSAGE.COVERAGE_TYPE.STANDARD_DESCRIPTION
  },
  {
    label: "Custom Catchment",
    value: EOutputCoverageType.CUSTOM_CATCHMENT,
    description: MESSAGE.COVERAGE_TYPE.CATCHMENT_DESCRIPTION
  }
];
